import { jsx as _jsx } from "react/jsx-runtime";
const containerStyle = {
    display: 'flex',
};
export function HeaderContainer(props) {
    const { style = {}, children } = props;
    return _jsx("div", { style: { ...containerStyle, ...style }, children: children });
}
